import script from "./Deposit.vue?vue&type=script&setup=true&lang=ts"
export * from "./Deposit.vue?vue&type=script&setup=true&lang=ts"

import "./Deposit.vue?vue&type=style&index=0&id=5a2c431e&lang=css"

const __exports__ = script;

export default __exports__